import React from 'react';

const Date = (props) => {
  const {
    label,
    value,
    id = null,
    onChange = () => {}
  } = props;
  const {
    labelClass = '',
    inputClass = '',
    formClass = 'form-group form-row',
    invalidFeedback = false,
    ...inputProps
  } = props;
  return (
    <div className={formClass}>
      { id && label &&
      <label htmlFor={id} className={`${labelClass}`}>
        {label}
      </label>
      }
      <div className={inputClass}>
        <input className='form-control datepicker' type='date'
               {...inputProps}
        />
        { invalidFeedback &&
        <div className="invalid-feedback">
          {invalidFeedback}
        </div>
        }
      </div>
    </div>
  );
};

export default Date;



// WEBPACK FOOTER //
// ./src/Common/SimpleDate.js